import React from 'react';
import { FormGroup, FloatingLabel, FloatingTrailingIconPositioner, FloatingError, FloatingHelperText } from '../styles';

/**
 * InputWrapper takes care of:
 * - Label and Label Placement
 * - Error state
 * - Helper text
 * - Trailing Icons within the input
 * */
export var FloatingInputWrapper = function FloatingInputWrapper(props) {
  var children = props.children,
      width = props.width,
      disabled = props.disabled,
      labelText = props.labelText,
      errorText = props.errorText,
      helperText = props.helperText,
      inputId = props.inputId,
      trailingIcon = props.trailingIcon,
      isFloating = props.isFloating,
      adjustToBackgroundColor = props.adjustToBackgroundColor;
  return /*#__PURE__*/React.createElement(FormGroup, {
    width: width,
    errorText: errorText,
    helperText: helperText
  }, /*#__PURE__*/React.createElement(FloatingLabel, {
    id: "".concat(inputId, "_label"),
    htmlFor: inputId,
    isFloating: isFloating,
    "data-test": "".concat(inputId, "_label"),
    adjustToBackgroundColor: adjustToBackgroundColor
  }, labelText), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.cloneElement(children, {
    'aria-describedby': helperText ? "".concat(inputId, "_helptext") : undefined,
    errorText: errorText
  }), trailingIcon && /*#__PURE__*/React.createElement(FloatingTrailingIconPositioner, {
    disabled: disabled,
    adjustToBackgroundColor: adjustToBackgroundColor
  }, /*#__PURE__*/React.cloneElement(trailingIcon, {
    size: 'xsmall'
  }))), errorText && /*#__PURE__*/React.createElement(FloatingError, {
    id: "".concat(inputId, "_error"),
    "data-test": "".concat(inputId, "_error"),
    role: 'alert'
  }, errorText), !errorText && helperText && /*#__PURE__*/React.createElement(FloatingHelperText, {
    id: "".concat(inputId, "_helptext"),
    "data-test": "".concat(inputId, "_helptext"),
    adjustToBackgroundColor: adjustToBackgroundColor
  }, helperText));
};
FloatingInputWrapper.displayName = 'FloatingInputWrapper';
export default FloatingInputWrapper;